<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UvdEYZ/tc-custom/9781466834590.jpg?1724535885371" alt="This image is the cover for the book War and Craft, American Craft Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">War and Craft, American Craft Series
      </h1>
      <p class="bookDescription body article font2">
        <p>America, land of the Free…and home of the warlocks.<br/><br/>The Founding Fathers were never ones to pass up a good weapon. America’s first line of defense has been shrouded in secrecy, magical families who have sworn to use their power to protect our republic.<br/><br/>But there are those who reject America’s dream and have chosen the Left Hand Path. In this triumphant conclusion to Tom Doyle’s imaginative alternate historical America, we start with a bloody wedding-night brawl with assassins in Tokyo. Our American magical shock troops go to India, where a descendant of legendary heroes has the occult mission they’ve been waiting for.<br/><br/>It all comes to a head in a valley hidden high in the mountains of Kashmir. Our craftspeople will battle against their fellow countrymen, some of the vilest monsters of the Left Hand Path. It’s Armageddon in Shangri-La, and the end of the world as we know it.<br/><br/><b>The American Craft Trilogy</b><br/>#1 <i>American Craftsmen</i><br/>#2 <i>The Left-Hand Way</i><br/>#3 <i>War and Craft</i><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Doyle
      </h2>
      
      <p class="authorDescription body article"><P>Award-winning author TOM DOYLE has survived Harvard, Stanford, and cancer. He runs, plays in a jam band, and listens to as many books as he reads. A graduate of the Clarion Writing Workshop, Doyle has won the WSFA Small Press Award and third prize in the Writers of the Future contest.<br><br>On <I>American Craftsmen, Library Journal</I> praised Doyle’s “well-crafted prose style, carefully paced plotting, and depth of characterization.”</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e0d3e7c6